import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ConfirmButton } from 'components/common';

import type { User } from 'shared-types';

interface Props {
  handleSuccess: () => Promise<void>;
  targetUser: Pick<User, 'id' | 'passwordSet'>;
}

const UsersUpdatePasswordSet = ({ handleSuccess, targetUser }: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleConfirm = async () => {
    try {
      await api.put(`/admin/users/${targetUser.id}`, {
        passwordSet: new Date()
      });

      await handleSuccess();

      dispatch(
        actions.addNotice({
          type: 'success',
          text: 'Resetting password enabled for user successfully.'
        })
      );
      return true;
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
      return false;
    }
  };

  return (
    <ConfirmButton
      actionText={messages.commonConfirm}
      buttonCategory="lighter"
      buttonIcon="key"
      buttonIsDropdown={true}
      buttonSize="medium"
      buttonText={'Enable reset password'}
      confirmText={
        "Are you sure you want to enable this user to reset their Vuolearning password? This will set the value of their 'passwordSet' field to the current date."
      }
      buttonTooltip={
        targetUser.passwordSet
          ? 'Resetting password is already enabled for this user'
          : ''
      }
      confirmTitle={'Enable reset password'}
      disabled={!!targetUser.passwordSet}
      onConfirm={handleConfirm}
    />
  );
};

export default UsersUpdatePasswordSet;
